var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVector46(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 403,
    viewBox: "0 0 263 403",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M261.057 401.402C236.204 374.87 232.452 369.323 217.942 343.626C214.387 337.33 209.086 325.315 204.455 310.74C203.066 306.378 201.854 302.076 200.783 297.851C193.154 267.62 195.968 235.331 203.062 204.041C221.166 124.207 187.561 45.216 124.301 14.7631C60.9326 -15.7398 -17.5846 9.0578 -61.1149 58.7257C-66.7784 65.1884 -92.0655 95.8851 -100.229 132.284C-126.034 247.203 -19.8691 309.3 146.601 368.274C149.839 369.418 165.348 374.224 168.651 375.158L261.067 401.415L261.057 401.402Z",
    stroke: "#E1E3E9",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector46);
export default __webpack_public_path__ + "static/media/vector4-6.49e1a48906a17f67abda467d43d8f714.svg";
export { ForwardRef as ReactComponent };